<template>
    <DRow>
        <DCard padding>
            <DTable
                v-if="accounts.length"
                :items="accounts"
                :fields="tableFields"
                hover
            >
                <template #name="{item}">
                    <td>
                        {{ item.name }}
                    </td>
                </template>
                <template #access_token_expires_at="{item}">
                    <td>
                        {{ item.settings?.access_token_expires_on ? new Date(item.settings.access_token_expires_on).toLocaleString('de') : '' }}
                    </td>
                </template>
                <template #refresh_token_expires_at="{item}">
                    <td>
                        {{ item.settings?.refresh_token_expires_on ? new Date(item.settings.refresh_token_expires_on).toLocaleString('de') : '' }}
                    </td>
                </template>
                <template #action="{item}">
                    <td>
                        <div class="d-flex align-items-center justify-content-end gap-1">
                            <DButton
                                id="authenticate"
                                :label="__('settings.microsoft365-settings.request_token')"
                                color="primary"
                                @click="authenticate(item.getCodeUrl)"
                            />
                            <DButton
                                v-if="item.settings !== null"
                                id="authenticate"
                                :label="__('settings.microsoft365-settings.manage_webhooks')"
                                color="primary"
                                :disabled="item.webhooks === null || item.accountWebhookConfig === null"
                                @click="openModal(item)"
                            />
                            <DButton
                                v-if="item.errorMessage"
                                v-c-tooltip="item.errorMessage ?? ''"
                                color="danger"
                                :label="''"
                                icon="note-alert"
                                @click="displayErrorMessage(item.errorMessage)"
                            />
                        </div>
                    </td>
                </template>
            </DTable>
            <div v-else>
                {{ __('settings.microsoft365-settings.no_accounts_available') }}
            </div>
        </DCard>
    </DRow>
    <ManageWebhooksModal
        v-if="showWebhooksModal"
        :show-modal="showWebhooksModal"
        is-confirm
        is-awaiting-validation
        is-big
        :all-webhooks="selectedAccount?.webhooks ?? []"
        :account-webhook-config="selectedAccount?.accountWebhookConfig ?? {}"
        :account-id="selectedAccount?.id ?? null"
        @close-modal="showWebhooksModal = false"
    />
</template>

<script setup>
import { ref } from 'vue'
import { usePage } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'
import ManageWebhooksModal from '~@/Pages/Settings/Microsoft365/ManageWebhooksModal.vue'

defineProps({
    accounts: {
        type: Array,
        default: () => []
    }
})

const tableFields = [
    { key: 'name', label: __('settings.microsoft365-settings.account_name') },
    { key: 'access_token_expires_at', label: __('settings.microsoft365-settings.access_token_expires_at') },
    { key: 'refresh_token_expires_at', label: __('settings.microsoft365-settings.refresh_token_expires_at') },
    { key: 'action', label: '' }
]

const showWebhooksModal = ref(false)
const selectedAccount = ref(null)

const authenticate = (url) => {
    window.open(url, '_blank')
}

const openModal = (item) => {
    selectedAccount.value = item
    showWebhooksModal.value = true
}

const displayErrorMessage = (message) => {
    usePage().props.flash.errorMessage = message
}
</script>

<style scoped>

</style>
